import { render, staticRenderFns } from "./EditorText.vue?vue&type=template&id=337534f1&"
import script from "./EditorText.vue?vue&type=script&setup=true&lang=js&"
export * from "./EditorText.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EditorText.vue?vue&type=style&index=0&id=337534f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports